import { RemoteApprovalGroup } from '../../../data/usecases/approval-group/approval-group'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeRemoteApprovalGroup = ():any => new RemoteApprovalGroup('/grupoaprovacao', makeAxiosHttpClient())

export const makeRemoteApprovalGroupById = (id:number):any => new RemoteApprovalGroup(`/grupoaprovacao/${id}`, makeAxiosHttpClient())

export const makeRemoteAllApprovalGroup = ():any => new RemoteApprovalGroup('/grupoaprovacao/all', makeAxiosHttpClient())
